import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { DataTexture, FloatType, MathUtils, RedFormat, LuminanceFormat, ShaderMaterial, UniformsUtils } from 'three';
import { Pass, FullScreenQuad } from './Pass.js';
import { DigitalGlitch } from '../shaders/DigitalGlitch.js';
var GlitchPass = /*#__PURE__*/function (_Pass) {
  _inherits(GlitchPass, _Pass);
  var _super = _createSuper(GlitchPass);
  function GlitchPass() {
    var _this;
    var dt_size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 64;
    _classCallCheck(this, GlitchPass);
    _this = _super.call(this);
    var shader = DigitalGlitch;
    _this.uniforms = UniformsUtils.clone(shader.uniforms);
    _this.heightMap = _this.generateHeightmap(dt_size);
    _this.uniforms['tDisp'].value = _this.heightMap;
    _this.material = new ShaderMaterial({
      uniforms: _this.uniforms,
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader
    });
    _this.fsQuad = new FullScreenQuad(_this.material);
    _this.goWild = false;
    _this.curF = 0;
    _this.generateTrigger();
    return _this;
  }
  _createClass(GlitchPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */) {
      if (renderer.capabilities.isWebGL2 === false) this.uniforms['tDisp'].value.format = LuminanceFormat;
      this.uniforms['tDiffuse'].value = readBuffer.texture;
      this.uniforms['seed'].value = Math.random(); //default seeding
      this.uniforms['byp'].value = 0;
      if (this.curF % this.randX == 0 || this.goWild == true) {
        this.uniforms['amount'].value = Math.random() / 30;
        this.uniforms['angle'].value = MathUtils.randFloat(-Math.PI, Math.PI);
        this.uniforms['seed_x'].value = MathUtils.randFloat(-1, 1);
        this.uniforms['seed_y'].value = MathUtils.randFloat(-1, 1);
        this.uniforms['distortion_x'].value = MathUtils.randFloat(0, 1);
        this.uniforms['distortion_y'].value = MathUtils.randFloat(0, 1);
        this.curF = 0;
        this.generateTrigger();
      } else if (this.curF % this.randX < this.randX / 5) {
        this.uniforms['amount'].value = Math.random() / 90;
        this.uniforms['angle'].value = MathUtils.randFloat(-Math.PI, Math.PI);
        this.uniforms['distortion_x'].value = MathUtils.randFloat(0, 1);
        this.uniforms['distortion_y'].value = MathUtils.randFloat(0, 1);
        this.uniforms['seed_x'].value = MathUtils.randFloat(-0.3, 0.3);
        this.uniforms['seed_y'].value = MathUtils.randFloat(-0.3, 0.3);
      } else if (this.goWild == false) {
        this.uniforms['byp'].value = 1;
      }
      this.curF++;
      if (this.renderToScreen) {
        renderer.setRenderTarget(null);
        this.fsQuad.render(renderer);
      } else {
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        this.fsQuad.render(renderer);
      }
    }
  }, {
    key: "generateTrigger",
    value: function generateTrigger() {
      this.randX = MathUtils.randInt(120, 240);
    }
  }, {
    key: "generateHeightmap",
    value: function generateHeightmap(dt_size) {
      var data_arr = new Float32Array(dt_size * dt_size);
      var length = dt_size * dt_size;
      for (var i = 0; i < length; i++) {
        var val = MathUtils.randFloat(0, 1);
        data_arr[i] = val;
      }
      var texture = new DataTexture(data_arr, dt_size, dt_size, RedFormat, FloatType);
      texture.needsUpdate = true;
      return texture;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.material.dispose();
      this.heightMap.dispose();
      this.fsQuad.dispose();
    }
  }]);
  return GlitchPass;
}(Pass);
export { GlitchPass };